import gql from 'graphql-tag';

export const GQL_GET_COMMENTS_AUTH = gql`
  query getCommentsAuth {
    me {
      _id
      commentsAuth {
        user
        hash
      }
    }
  }
`;
